var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 25.033a17.314 17.314 0 0 1-4.948 1.35 8.608 8.608 0 0 0 3.788-4.748c-1.69 1-3.541 1.704-5.471 2.081a8.652 8.652 0 0 0-10.36-1.7 8.599 8.599 0 0 0-3.787 4.033 8.55 8.55 0 0 0-.537 5.495 24.55 24.55 0 0 1-9.837-2.602 24.452 24.452 0 0 1-7.924-6.364 8.549 8.549 0 0 0-1.165 4.314c0 1.412.349 2.803 1.017 4.05a8.597 8.597 0 0 0 2.816 3.093 8.622 8.622 0 0 1-3.903-1.074v.11c0 1.982.688 3.902 1.948 5.436a8.626 8.626 0 0 0 4.964 2.979c-1.27.342-2.6.392-3.892.147a8.586 8.586 0 0 0 3.066 4.264 8.646 8.646 0 0 0 4.984 1.693 17.338 17.338 0 0 1-10.702 3.674c-.688 0-1.374-.04-2.057-.12A24.445 24.445 0 0 0 29.207 55c15.852 0 24.518-13.074 24.518-24.413 0-.369-.009-.74-.026-1.11a17.476 17.476 0 0 0 4.297-4.439l.004-.005Z",
    fill: "#FBFAFA"
  })));
};

export default SvgTwitter;